import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mobilitySurveyDemotivationReasons } from '../../models';
import StatsCard from './stats-card';
export const transportHabitsDemotivationReasonsMap = {
  notComfortableCycling: {
    labelKey: 'commons.transport_habits.demotivation_reasons.not_comfortable_cycling',
    shortKey: 'commons.transport_habits.demotivation_reasons.not_comfortable_cycling_short',
    captionKey: undefined
  },
  fearForMySafety: {
    labelKey: 'commons.transport_habits.demotivation_reasons.fear_for_my_safety',
    shortKey: 'commons.transport_habits.demotivation_reasons.fear_for_my_safety_short',
    captionKey: undefined
  },
  tooMuchEffort: {
    labelKey: 'commons.transport_habits.demotivation_reasons.too_much_effort',
    shortKey: 'commons.transport_habits.demotivation_reasons.too_much_effort_short',
    captionKey: undefined
  },
  weather: {
    captionKey: 'commons.transport_habits.demotivation_reasons.weather_caption',
    labelKey: 'commons.transport_habits.demotivation_reasons.weather',
    shortKey: 'commons.transport_habits.demotivation_reasons.weather_short'
  },
  logisticalConstraints: {
    labelKey: 'commons.transport_habits.demotivation_reasons.logistical_constraints',
    shortKey: 'commons.transport_habits.demotivation_reasons.logistical_constraints_short',
    captionKey: 'commons.transport_habits.demotivation_reasons.logistical_constraints_caption'
  },
  noBikeOrNotInGoodCondition: {
    labelKey: 'commons.transport_habits.demotivation_reasons.no_bike_or_not_in_good_condition',
    shortKey: 'commons.transport_habits.demotivation_reasons.no_bike_or_not_in_good_condition_short',
    captionKey: 'commons.transport_habits.demotivation_reasons.no_bike_or_not_in_good_condition_caption'
  },
  fearOfTheft: {
    labelKey: 'commons.transport_habits.demotivation_reasons.fear_of_theft',
    shortKey: 'commons.transport_habits.demotivation_reasons.fear_of_theft_short',
    captionKey: undefined
  },
  noEquipmentAtWork: {
    labelKey: 'commons.transport_habits.demotivation_reasons.no_equipment_at_work',
    shortKey: 'commons.transport_habits.demotivation_reasons.no_equipment_at_work_short',
    captionKey: undefined
  },
  satisfiedOfMyCurrentCommuting: {
    labelKey: 'commons.transport_habits.demotivation_reasons.satisfied_of_my_current_commuting',
    shortKey: 'commons.transport_habits.demotivation_reasons.satisfied_of_my_current_commuting_short',
    captionKey: undefined
  },
  haveADisability: {
    labelKey: 'commons.transport_habits.demotivation_reasons.have_a_disability',
    shortKey: 'commons.transport_habits.demotivation_reasons.have_a_disability_short',
    captionKey: undefined
  },
  other: {
    labelKey: 'commons.transport_habits.demotivation_reasons.other',
    shortKey: 'commons.transport_habits.demotivation_reasons.other_short',
    captionKey: undefined
  }
};
export function TransportHabitsDemotivationReasons({
  progressBarWidth,
  stats
}) {
  const [items, setItems] = useState();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setItems(stats ? mobilitySurveyDemotivationReasons.map(key => ({
      key,
      label: t(transportHabitsDemotivationReasonsMap[key].labelKey),
      count: stats.demotivationReasons[key] || 0
    })).sort((a, b) => b.count - a.count) : undefined);
  }, [stats]);
  return /*#__PURE__*/React.createElement(StatsCard, {
    items: items,
    progressBarColor: "#F36565",
    progressBarWidth: progressBarWidth,
    respondantsCount: stats?.demotivationReasonsRespondantsCount,
    title: t('commons.transport_habits.demotivation_reasons.title')
  });
}